var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99967 11.0708C4.99967 9.6958 5.55801 8.4458 6.46634 7.53747L5.28301 6.35413C4.08301 7.56247 3.33301 9.22913 3.33301 11.0708C3.33301 14.4708 5.87467 17.2708 9.16634 17.6791V15.9958C6.80801 15.5958 4.99967 13.5458 4.99967 11.0708ZM16.6663 11.0708C16.6663 7.38747 13.683 4.40413 9.99967 4.40413C9.94967 4.40413 9.89967 4.41247 9.84967 4.41247L10.758 3.50413L9.58301 2.3208L6.66634 5.23747L9.58301 8.15413L10.758 6.97913L9.85801 6.07913C9.90801 6.07913 9.95801 6.0708 9.99967 6.0708C12.758 6.0708 14.9997 8.31247 14.9997 11.0708C14.9997 13.5458 13.1913 15.5958 10.833 15.9958V17.6791C14.1247 17.2708 16.6663 14.4708 16.6663 11.0708Z",
    fill: "#002d62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoReset);
export default __webpack_public_path__ + "static/media/so_reset.25f84eef95f0f20591f98c3034fff33c.svg";
export { ForwardRef as ReactComponent };